import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { LoggingService } from '../../services/logging.service';

@Component({
  template: `
    <div class="grid justify-center items-center text-center p-8">
      <p>Sorry. This path is not found.</p>
      <div>
        <a routerLink="/workspaces/finprogw/dashboard">Main Page</a>
      </div>
    </div>
  `,
  styleUrls: ['./path-not-found.component.scss'],
  standalone: true,
  imports: [RouterLink],
})
export class PathNotFoundComponent implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private loggingService = inject(LoggingService);

  ngOnInit() {
    this.loggingService.log(`Path not found: ${this.route.pathFromRoot}`);
  }
}
